import { useMemo } from "react";
import { m, useReducedMotion } from "framer-motion";
import { DUR, EASE_ENTER } from "./tokens";

const COLORS = ["var(--color-primary)", "var(--color-primary-light)", "var(--color-accent)", "var(--color-accent-pink)"];

export function Confetti({ fire }: { fire: boolean }) {
  const reduce = useReducedMotion();
  const pieces = useMemo(
    () => Array.from({ length: 28 }, (_, i) => ({
      i, x: (Math.random() - 0.5) * 520, y: -(180 + Math.random() * 220), r: (Math.random() - 0.5) * 540,
      delay: Math.random() * 0.12, w: 6 + Math.random() * 6, color: COLORS[i % COLORS.length],
    })),
    [],
  );
  if (reduce || !fire) return null;
  return (
    <div aria-hidden className="pointer-events-none absolute inset-x-0 top-1/3 flex justify-center overflow-visible">
      {pieces.map((p) => (
        <m.span
          key={p.i}
          data-confetti
          className="absolute block rounded-[2px]"
          style={{ width: p.w, height: p.w * 0.45, background: p.color }}
          initial={{ x: 0, y: 0, rotate: 0, opacity: 1 }}
          animate={{ x: p.x, y: [0, p.y, p.y + 420], rotate: p.r, opacity: [1, 1, 0] }}
          transition={{ duration: DUR.hero * 1.8, ease: EASE_ENTER, delay: p.delay, times: [0, 0.35, 1] }}
        />
      ))}
    </div>
  );
}
